import {Injectable} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {isADate} from 'app/global/fieldvalidation';
import {MetaDataTypeEnum} from 'app/main/pages/settings/documentfields/metadata-item.dto';
import {DocumentTypeCustomBoxes} from '../../../dto/document-listing.dto';

@Injectable({
    providedIn: 'root'
})

export class CustomBoxManupilator {

    constructor(private _formBuilder: FormBuilder) { }


    manupilateCustomBoxes(customBoxes: DocumentTypeCustomBoxes[], aiData: {
        [p: string]: string | number | boolean | string[] | number[] | boolean[] | []
    } | undefined = {}) {
        return customBoxes?.map(item => {
            return {
                ...item,
                document_type_custom_boxes_data: item?.document_type_custom_boxes_data.map(box => {
                    return {
                        ...box,
                        value: ((box)?.value) ?? this.matchAIData(box, aiData)
                    };
                })
            };
        })
    }


    createBoxGroup(box: DocumentTypeCustomBoxes, aiData?: {
        [p: string]: string | number | boolean | string[] | number[] | boolean[] | []
    } | undefined) {
        return this._formBuilder.group({
            id: [box.id],
            name: [box.name],
            document_type_custom_boxes_data: this._formBuilder.array(
                box.document_type_custom_boxes_data.map(customBox =>
                    this._formBuilder.group({
                        id: [customBox.document_type_box_id],
                        custom_boxes_data_id: [customBox.id],
                        document_type_box_id: [customBox.document_type_box_id],
                        field_order: [customBox.field_order],
                        order: [customBox.field_order],
                        value: [customBox.value ?? this.matchAIData(box, aiData)],
                        meta_data: [customBox.meta_data]
                    })
                )
            )
        })
    }
    
    private matchAIData(box, aiData){
        return this.getAiProcessedValue(box, aiData) ?? '';
    }
    
    private hasAiDataDefined(box, aiData){
        if(box?.meta_data?.api_attribute != null && aiData != null){
           return  Object.keys(aiData).some(x=> x === box.meta_data.api_attribute);
        }
        return false
    }
    
    private getAiProcessedValue(box, aiData){
        if(this.hasAiDataDefined(box, aiData)){
            return  this.matchAIDataByCustomBoxType( box, aiData[box.meta_data.api_attribute]);
        }
        return '';
    }

    private matchAIDataByCustomBoxType(box, aiData){
        if(aiData === null || aiData === undefined){
            return null;
        }
        
        switch(box?.meta_data?.meta_data_type){
            case MetaDataTypeEnum.checkbox:
                {
                    return this.mapCheckboxValue(aiData);
                }
            case MetaDataTypeEnum.datepicker:
                {
                    return this.mapDatePickerValue(box, aiData);
                }
            case MetaDataTypeEnum.droplist:{
                return this.mapDropDownItemValue(box, aiData);
            }        
            default:
                {
                    return aiData;

                }
        }

    }

    private mapCheckboxValue(value: boolean | number | string): '0' | '1' | ''{
        if(typeof value === 'boolean'){
            return  value ? '1' : '0';
        }
        
        if(value === ''){
            return '';
        }
        
        return (+value) === 1 
            ? '1' 
            : (+value) === 0
                ? '0'
                : '';
    }

    private mapDatePickerValue(box, aiData): string | Date{
        return aiData && isADate(aiData) ? aiData : null;
    }

    private mapDropDownItemValue(box, aiData):string{
         return  box.meta_data?.meta_data_option?.find(x=>x.value.toString().toLowerCase() === aiData?.toString().trim().toLocaleLowerCase())?.value ?? null;
    }
}